import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StreakCounter from "../../../../components/StreakCounter";

const TILE_COLORS = {
  2: "#abc9eb",
  4: "#89aed8",
  8: "#6999cf",
  16: "#4c83c2",
  32: "#4ca6c2",
  64: "#59b8a7",
  128: "#82b879",
  256: "#b6bf73",
  512: "#baa5d9",
  1024: "#e0a580",
};

const GameHUD = ({
  score,
  bestScore,
  nextBlock,
  currentDate,
  streak,
  isStreakActive,
  isMuted,
  onHelp,
  onMute,
  onDateClick,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    {/* Top row: Controls, Date, Streak */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 1,
      }}
    >
      {/* Left: Help and Sound controls */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="How to Play">
          <IconButton onClick={onHelp} sx={{ color: "#222" }}>
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={isMuted ? "Unmute" : "Mute"}>
          <IconButton onClick={onMute} sx={{ color: "#222" }}>
            {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
          </IconButton>
        </Tooltip>
      </Box>
      {/* Center: Date */}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "1.25rem",
          color: "#222",
          cursor: "pointer",
          textDecoration: "underline",
          transition: "text-decoration 0.2s",
          "&:hover": { textDecoration: "underline dotted" },
        }}
        onClick={onDateClick}
      >
        {currentDate.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })}
      </Typography>
      {/* Right: Streak */}
      <Tooltip title="Keep playing daily to unlock special features!">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <StreakCounter isActive={isStreakActive} streak={streak} />
        </Box>
      </Tooltip>
    </Box>
    {/* Bottom row: Score, Next, Best */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {/* Left: Score */}
      <Chip
        label={`Score: ${score}`}
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.1)",
          "& .MuiChip-label": { fontWeight: 600, color: "#000000" },
        }}
      />
      {/* Center: Next Block */}
      <Chip
        label={
          <>
            <b>Next:</b> <span style={{ marginLeft: 4 }}>{nextBlock}</span>
          </>
        }
        sx={{
          bgcolor: TILE_COLORS[nextBlock] || "#eee",
          color: "#222",
          fontWeight: 600,
          fontSize: 16,
          mx: 1,
          "& .MuiChip-label": { color: "#222", fontWeight: 700 },
        }}
      />
      {/* Right: Best Score */}
      <Chip
        icon={<EmojiEventsIcon sx={{ color: "#FFD700" }} />}
        label={`Best: ${bestScore !== null ? bestScore : "---"}`}
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.1)",
          "& .MuiChip-label": { fontWeight: 600, color: "#222" },
        }}
      />
    </Box>
  </Box>
);

export default GameHUD;
